<template>
<md-app class="app" md-mode="fixed">

  <nav-bar slot="md-app-toolbar"></nav-bar>

  <md-app-drawer id="sidebar" :md-permanent.sync="$store.state.sidebarType" md-scrollbar :md-active.sync="$store.state.sidebarActive">
    <md-toolbar md-elevation="0">
      <span>{{ $t('table_of_contents') }}</span>
    </md-toolbar>

    <md-list>
      <div v-for="slideshow in report.slideshows" :key="slideshow._id">
        <md-list-item @click="scrollTo(`#slideshow-${slideshow._id}`)">
          <md-icon>photo_library</md-icon>
          <span class="md-list-item-text" style="white-space:normal">{{ slideshow.title }}</span>
        </md-list-item>
      </div>
    </md-list>
  </md-app-drawer>

  <md-app-content>
    <md-app id="content">
      <md-app-content>
        <div class="content-container mb-4">

          <div v-if="report.header_image" :ref="`header-image-${report._id}`" class="lf-header-image no-content-padding">
            <div v-if="$store.state.screenSize !== 'desktop'">
              <div class="lf-mobile-back-button">
                <md-button
                  class="md-raised"
                  @click="$router.push({ name: 'start' })">
                  {{ $t('back') }}
                </md-button>
              </div>
            </div>
            <div class="lf-header-bar content-padding">
              <h1 v-if="report.title">{{ report.title }}</h1>
            </div>
          </div>

          <div v-else>
            <div v-if="$store.state.screenSize !== 'desktop'">
              <div class="lf-mobile-header-bar no-content-padding">
                <md-button
                  class="md-raised"
                  @click="$router.push({ name: 'start' })">
                  {{ $t('back') }}
                </md-button>
              </div>
            </div>
            <h1 v-if="report.title">{{ report.title }}</h1>
          </div>

          <div v-if="report.description" id="description" class="mt-5">
            <p>{{ report.description }}</p>
          </div>

          <div class="slideshow-container">
            <div
              v-for="slideshow in report.slideshows"
              :key="slideshow._id"
              :id="`slideshow-${slideshow._id}`"
              class="mt-5">
              <h2 v-if="slideshow.title">{{ slideshow.title }}</h2>
              <div v-if="slideshow.description" v-html="slideshow.description" />
              <slideshow :slideshow="slideshow" />
            </div>
          </div>

        </div>
      </md-app-content>
    </md-app>
  </md-app-content>
</md-app>
</template>

<script>

export default {
  name: 'Report',
  data: () => ({
    report: {}
  }),
  mounted () {
    this.$store.dispatch('getReport', this.$route.params.id)
      .then(report => {
        this.report = report
        this.setHeaderImage(report)
      })
      .catch(err => console.error(err))
  },
  methods: {
    scrollTo (id) {
      var el = this.$el.querySelector(id)
      var style = window.getComputedStyle(el)
      const { marginTop, paddingTop } = style
      const offset = 30
      const marginTopOffset = parseInt(marginTop, 10) - offset
      const paddingTopOffset = parseInt(paddingTop, 10) + offset

      // Set offset for target element
      el.setAttribute('style', `margin-top: ${marginTopOffset}px !important; padding-top: ${paddingTopOffset}px !important`)
      // Scroll to element
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'start'
      })
      // Remove offset
      el.setAttribute('style', `margin-top: ${marginTop} !important; padding-top: ${paddingTop} !important`)
      // Hide sidebar
      this.$store.dispatch('setSidebarActive', false)
    },
    setHeaderImage (report) {
      // Request header image for report
      if (report.header_image) {
        this.$store.dispatch('getFile', report.header_image)
          .then(image => {
            const $el = this.$refs[`header-image-${report._id}`] // Get element that displays header image
            $el.style.backgroundImage = `url(${image})` // Set header image as background image
            this.$store.dispatch('setLoading', false)
          })
          .catch(err => console.error(err))
      } else {
        this.$store.dispatch('setLoading', false)
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    // Unset report when leaving the page
    this.report = {}
    next()
  },
  watch: {
    '$route': function (to) {
      if (to.name === 'report' && to.params.id) {
        this.$store.dispatch('getReport', to.params.id)
          .then(report => {
            this.report = report
            this.setHeaderImage(report)
          })
          .catch(err => console.error(err))
      }
    }
  }
}
</script>

<style lang="scss">
  @import "../styles/theme";

  #sidebar {
    .md-list-item {
      &:hover {
        cursor: pointer;
        .md-list-item-text {
          color: $primary;
        }
      }
    }
  }

  .lf-header-image {
    height: 400px;
    background-image: url('../assets/image-default.jpg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    position: relative;
    margin-top: -$content-padding
  }
  .lf-header-bar {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(255,255,255,0.85);
    border-bottom: 1px solid $border;
  }
  .lf-mobile-header-bar {
    margin-top: -$content-padding-mobile;
    background-color: $grey-light;
    border-bottom: 1px solid $border;
    padding: $content-padding-mobile;
  }
  .lf-mobile-back-button {
    position: absolute;
    left: $content-padding-mobile;
    top: $content-padding;
  }
</style>
